import {Component, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {ParcelsService} from '../../../services/parcels.service';
import {Parcel, ResidentForSelect, SettingsParcels} from '../../../types/data.types';
import {UrlService} from '../../../services/url.service';
import {AccountPermissionsService} from '../../../services/account-permissions.service';
import {Http, RequestOptions, Headers, Response} from '@angular/http';
import {environment} from '../../../../environments/environment';
import {AuthTokenService} from '../../../services/auth-token.service';

declare const toastr: any;

type Receiver = ResidentForSelect & { photo: string, signature: string };

@Component({
    selector: 'transit-parcel-modal',
    templateUrl: './transit-parcel-modal.component.html',
    styleUrls: ['./transit-parcel-modal.component.scss']
})
export class TransitParcelModalComponent implements OnInit, OnDestroy {
    @ViewChild('form') form;

    showModal = false;
    action = 'pick_up';
    parcel: Parcel;
    residents: Array<ResidentForSelect> = [];
    data: Parcel[] = [];
    disabledSubmit = false;
    signatureStatus: 0 | 1 = 1;
    useSignaturePadStatus: boolean = false;
    receiver: Receiver = null;
    showReferenceSignatureStatus = false;
    showResidentPhotoStatus = false;
    isPatchReferenceSignature = false;
    successfullyAddedEmail = '';
    cancellationResident = null;
    photoIsUpdating = false;

    constructor(
        public http: Http,
        public api: ApiClientService,
        public urlService: UrlService,
        public authTokenService: AuthTokenService,
        public accountService: AccountPermissionsService,
        private parcelsService: ParcelsService
    ) {
    }

    ngOnInit() {
        this.parcel = this.parcelsService.parcelInTransitModal;
        this.action = this.parcelsService.statusInTransitModal;
        this.getParcelSetting(this.parcel.corporationNumberBd);
        if (+this.parcel.suiteId) {
            this.getResidents(this.parcel.suiteId);
            this.getParcelsInSuite(this.parcel.suiteId);
        } else {
            this.parcel.checked = true;
            this.data.push(this.parcel);
        }
        setTimeout(() => this.showModal = true, 300);
        this.urlService.modalOpened.emit();

        this.parcelsService.imageCaptured.subscribe(image => this.changeAvatar({target: {files: [image]}}));
    }

    hideModal() {
        this.parcelsService.parcelInTransitModal = null;
        this.parcelsService.isTransitModalShow = false;
        this.urlService.modalClosed.emit();
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            toastr.warning('Send data not valid');
            return;
        }
        const data: any = {};
        data.transition = this.action;

        if (this.action === 'pick_up') {
            if (this.parcel.isOutgoingParcel()) {
                data.pickedUpByPostService = form.value.pickedUpByPostService != -1 ? form.value.pickedUpByPostService : undefined;
                if (form.value.pickedUpByPostService == -1) {
                    data.pickedUpByPostServiceName = form.value.pickedUpByPostServiceName;
                }
            } else {
                data.pickedUpBy = this.getResidentObj(form);
            }
        } else if (this.action === 'return') {
            data.returningBy = form.value.returningBy;
        } else if (this.action === 'cancel') {
            data.cancelledBy = this.getResidentObj(form);
        }


        if (form.value.sign && this.useSignaturePadStatus) {
            if (!form.value.signBase) {
                toastr.warning('Signature should not be blank.');
                return;
            }
            data.signBase = form.value.signBase;
        }
        this.submitRequests(data);
    }

    submitRequests(data) {
        this.disabledSubmit = true;
        this.data.filter(item => item.checked).forEach(item => {
            const parcelUrl = `/v1/parcels/transit/${item.id}.json`;
            this.api.patch('domainParcels', parcelUrl, data).subscribe(
                () => this.updateView('Parcel successfully updated'),
                error => {
                    this.disabledSubmit = false;
                    this.api.errorHandler(error, 'Update parcel failed');
                }
            );
        });

        const residentBd = this.receiver || this.cancellationResident || {};

        // Update user reference signature
        if (this.signatureStatus && this.isPatchReferenceSignature && this.accountService.canRead('bldn') && data.signBase && residentBd.id) {
            const residentUrl = `/v1/residents_signature/${residentBd.id}.json`;

            this.api.patch('domainBD', residentUrl, {signature: data.signBase}).subscribe(
                () => toastr.success('Reference Signature updated'),
                error => this.api.errorHandler(error, 'Update Reference Signature failed')
            );
        }
    }

    getResidentObj(form) {
        const resident = this.residents.find((r) => r.id == form.value.residentId);
        const result: any = {
            bdId: resident ? resident.id : 0,
            fullName: resident ? resident.fullName : form.value.otherResident,
        };

        if (resident && resident.email) result.email = resident.email;

        return result;

    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.form.reset();
        this.hideModal();
        this.parcelsService.getData();
    }

    getResidents(suiteId: number): void {
        this.residents = [];
        const url = `/v1/suites/${suiteId}.json?expand=suiteUser,suiteUser.user&per-page=1000`;
        this.api.get('domainBD', url).subscribe(
            res => {
                const suite = JSON.parse(res._body);
                suite.suiteUser.forEach((item) => {
                    let resident = new ResidentForSelect(item.user.id, item.user.fullName, [], item.user.email);
                    (<any>resident).photo = item.user.photo;
                    (<any>resident).signature = item.user.signature;
                    (<any>resident).suiteUserId = item.id;
                    (<any>resident).building = item.building;
                    this.residents.push(resident);
                });
                this.residents.sort((a: any, b: any) => {
                    if (a.fullName > b.fullName)
                        return 1;
                    else if (a.fullName < b.fullName)
                        return -1;
                    else
                        return 0;
                });
                if (!this.successfullyAddedEmail) {
                    if (this.action !== 'cancel' && this.parcel.residentId && !this.receiver)
                        this.onReceiverChange({target: {value: this.parcel.residentId}});
                    if (this.action === 'cancel')
                        this.onCancellationResidentChange({target: {value: this.parcel.residentId}});
                }
            },
            error => this.api.errorHandler(error, 'Failed get Residents'));
    }

    getParcelsInSuite(suiteId: number) {
        this.data = [];
        const url = `/v1/parcels.json?expand=building,suite,resident,receivedBy,pickedUpBy,deliveredBy` +
            `&suite_id=${suiteId}&status[0]=received&inOut=${this.parcel.inOut}&per-page=1000&order-by=id|desc`;
        this.api.get('domainParcels', url).subscribe(
            res => {
                const body = JSON.parse(res._body);
                const entities = body.entities;
                this.parcelsService.parcelsFactory(entities, this.data);
                this.data.find((p) => p.id == this.parcel.id).checked = true;
            },
            error => this.api.errorHandler(error, 'Failed get Residents'));

    }

    getParcelSetting(corporationNumberId: number) {
        const url = `/v1/parcel-service-settings/${corporationNumberId}.json`;
        this.api.get('domainParcels', url).map((response: Response) => response.json()).subscribe(res => {
            let settings = new SettingsParcels();
            settings = Object.assign(settings, res);
            this.useSignaturePadStatus = settings.useSignaturePadStatus;
            this.showReferenceSignatureStatus = settings.showReferenceSignatureStatus;
            this.showResidentPhotoStatus = settings.showResidentPhotoStatus;
        });
    }

    toggleCheckedAll() {
        const targetValue = !this.isCheckedAll();
        this.data.map(item => item.checked = targetValue);
    }

    isCheckedAll() {
        return this.data.every(item => item.checked);
    }

    isSomeChecked() {
        return this.data.some(item => item.checked);
    }

    onReceiverChange(event) {
        this.receiver = <Receiver>this.residents.find(res => res.id == event.target.value);
        this.isPatchReferenceSignature = this.receiver && !this.receiver.signature;
        this.successfullyAddedEmail = '';
    }

    onCancellationResidentChange(event) {
        this.cancellationResident = this.residents.find(res => res.id == event.target.value);
        this.isPatchReferenceSignature = this.cancellationResident && !this.cancellationResident.signature;
        this.successfullyAddedEmail = '';
    }

    updateResidentEmail() {
        if (!this.emailIsValid(this.form.value.email)) {
            toastr.warning(`Email ${this.form.value.email} is invalid.`);
            return;
        }
        const email = this.form.value.email;
        const url = `/v1/public/check_sender/${email}`;
        this.api.get('domainNotifications', url).subscribe(
            res => {
                const suiteUser = this.residents.find(r => r.id == this.form.value.residentId);
                const url = `/v1/suite-users/${(<any>suiteUser).suiteUserId}`;
                const data = {user: {email: this.form.value.email}};
                this.api.patch('domainBD', url, data).subscribe(
                    res => {
                        this.successfullyAddedEmail = email;
                        toastr.success('Email is added to resident file successfully.');
                        if (+this.parcel.suiteId)
                            this.getResidents(this.parcel.suiteId);
                    },
                    error => this.api.errorHandler(error, 'Failed to add email.')
                );
            },
            error => this.api.errorHandler(error, 'Failed to verify entered email.')
        );
    }

    emailIsValid(email) {
        return email.match('[a-zA-Z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?');
    }

    canEditDirectory() {
        if (this.receiver || this.cancellationResident) {
            const person = this.receiver || this.cancellationResident;
            return this.accountService.canUpdate('bldn', person.building);
        } else
            return false;
    }

    takeImageFromWebcam(event) {
        event.stopPropagation();
        this.parcelsService.showImageCaptureModal = true;
    }

    changeAvatar(e) {
        this.photoIsUpdating = true;
        const file = e.target.files[0];
        const fd = new FormData();
        e.target.value = null;

        fd.append('fileUpload', file);
        fd.append('_format', 'json');

        const token = this.authTokenService.accessToken;
        const headers = new Headers({'Authorization': `Bearer ${token}`});
        const options = new RequestOptions({headers: headers});

        this.http.post(`${environment.domainEmails}/_uploader/attachments/upload`, fd, options)
            .map((response: Response) => response.json()).subscribe(
            res => {
                if (!res.path) {
                    toastr.warning('File path should not be blank.');
                    return;
                }

                this.updateResidentPicture({photo: res.path});
            },
            error => {
                this.photoIsUpdating = false;
                this.parcelsService.api.errorHandler(error, 'Upload file failed');
            }
        );
    }

    updateResidentPicture(data) {
        const entity = this.receiver || this.cancellationResident;
        const url = `/v1/residents/${entity.id}.json`;

        this.api.patch('domainBD', url, data).subscribe(
            res => {
                entity.photo = data.photo;
                toastr.success('Image was uploaded successfully!');
            },
            error => this.parcelsService.api.errorHandler(error, 'Failed to upload image'),
            () => this.photoIsUpdating = false
        );
    }

    ngOnDestroy() {
        this.parcelsService.imageCaptured.observers = [];
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/parcels/transit-parcel-modal/transit-parcel-modal.component.ts